import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-assign-promotions-smart',
  template: '<app-assign-promotions [codeGroups]="codeGroups" [carrierDetails]="carrierDetails" [serviceCountries]="serviceCountries"></app-assign-promotions>',
  styles: [
  ]
})
export class AssignPromotionsSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  // providers: any;
  serviceCountries: [];
  codeGroups: [];
  carrierDetails: [];
  productId: any;
  
  constructor(private promotionsService: PromotionsService, private activeRoute: ActivatedRoute) {
    super();
    this.getAllProductServiceData();
  }

  getAllProductServiceData() {
    this.productId = this.activeRoute.snapshot.params.id;
    let carrierDetails = this.promotionsService.getcarrierPromotionsId(this.productId);
    let codeGroups = this.promotionsService.getcodeGroups();
    let serviceCountries = this.promotionsService.getCarrierCountries();

    forkJoin([carrierDetails, codeGroups, serviceCountries]).subscribe(
      res => {
        this.carrierDetails = res[0]['data'];
       
        this.codeGroups = res[1].data;
        this.serviceCountries = res[2]['data'];
      }
    );
  }


  ngOnInit(): void {
    super.ngOnInit();

  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
